import { createSlice } from "@reduxjs/toolkit";

const sipSlice = createSlice({
  name: "sip",
  initialState: {
    loading: false,
    sipPlans: null,
    sipTemplatePlans: null,
    totalcount: 0,
    error: null,
    createdSipOrder: null,
    sipOfflineLoading: false,
    sipOfflineOrder: null,
    sipOfflineError: null,
  },
  reducers: {
    getSipPlansRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getSipPlansSuccess: (state, action) => {
      state.loading = false;
      state.sipPlans = action.payload.data || [];
    },
    getSipPlansFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getSipTemplateRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getSipTemplateSuccess: (state, action) => {
      state.loading = false;
      state.sipTemplatePlans = action.payload.data || [];
      state.totalCount = action.payload.total || 0;
    },
    getSipTemplateFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createOfflineSipPaymentRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createOfflineSipPaymentSuccess: (state, action) => {
      state.loading = false;
      state.createdSipOrder = action.payload;
    },
    createOfflineSipPaymentFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createOfflineSipInstallmentRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createOfflineSipInstallmentSuccess: (state, action) => {
      state.loading = false;
      state.createdSipOrder = action.payload;
    },
    createOfflineSipInstallmentFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetCreatedSipOrder: (state) => {
      state.createdSipOrder = null;
    },
    createSipOfflineOrderRequest: (state) => {
      state.sipOfflineLoading = true;
      state.sipOfflineError = null;
    },
    createSipOfflineOrderSuccess: (state, action) => {
      state.sipOfflineLoading = false;
      state.sipOfflineOrder = action.payload;
      state.sipOfflineError = null;
    },
    createSipOfflineOrderFailure: (state, action) => {
      state.sipOfflineLoading = false;
      state.sipOfflineError = action.payload;
    },
    resetSipOfflineOrder: (state) => {
      state.sipOfflineLoading = false;
      state.sipOfflineOrder = null;
      state.sipOfflineError = null;
    },
  },
});

export const {
  getSipPlansRequest,
  getSipPlansSuccess,
  getSipPlansFailure,
  getSipTemplateRequest,
  getSipTemplateSuccess,
  getSipTemplateFailure,
  createOfflineSipPaymentRequest,
  createOfflineSipPaymentSuccess,
  createOfflineSipPaymentFailure,
  createOfflineSipInstallmentRequest,
  createOfflineSipInstallmentSuccess,
  createOfflineSipInstallmentFailure,
  resetCreatedSipOrder,
  createSipOfflineOrderRequest,
  createSipOfflineOrderSuccess,
  createSipOfflineOrderFailure,
  resetSipOfflineOrder,
} = sipSlice.actions;

export default sipSlice.reducer;
